import { IStyle, mergeStyleSets } from '@fluentui/react';

export const HelpPanelUl = styled.ul`
    list-style: disc;
    padding-left: 25px;
`;

export interface IHelpViewClassNames {
    helpSectionTitle?: string;
    helpSeparator?: string;
    link?: string;
    helpTextBreak?: string;
    smallTextBreak?: string;
}

const helpSectionTitleStyle: IStyle = {
    fontWeight: 500,
    padding: 0,
    marginBottom: 15
};

const helpSeparatorStyle: IStyle = {
    marginBottom: '24px',
    fontWeight: 400,

    selectors: {
        ':not(:first-child)': { marginTop: '24px' },
        '::before': { background: 'rgb(229, 229, 229)' }
    }
};
const linkStyle: IStyle = {
    fontWeight: 600,
    marginBottom: 16,
    selectors: {
        '&:hover': { textDecoration: 'underline' },
        '&:focus': { textDecoration: 'underline' }
    }
};

const helpTextBreakStyle: IStyle = {
    marginBottom: 10
};
const smallTextBreakStyle: IStyle = {
    marginBottom: 8
};

export const getClassNames = (): IHelpViewClassNames => {
    return mergeStyleSets({
        helpSectionTitle: helpSectionTitleStyle,
        helpSeparator: helpSeparatorStyle,
        link: linkStyle,
        helpTextBreak: helpTextBreakStyle,
        smallTextBreak: smallTextBreakStyle
    });
};
